module.exports = __webpack_public_path__ + "static/img/tong.ba1dca63.png";